export default __webpack_public_path__ + "static/media/Poor.53a6f62c.svg";